import { useMutation } from '@tanstack/react-query';
import { useToast } from 'components/Providers/ToastProvider';
import { useSearchAiPluginStore } from 'store/searchAiPluginStore';

export const useUpdateCustomization = () => {
    const { showMessage } = useToast();
    const { updateCustomization } = useSearchAiPluginStore();
    return useMutation({
        mutationFn: updateCustomization,
        onSuccess: () => showMessage('Success', 'Customization Updated Successfully'),
        onError: (error) => showMessage('Error', error.message),
    });
};
